import axios from "axios";
import Vue from "vue";
import { find, head } from 'lodash';
import { WebCam } from 'vue-web-cam';
import * as files from '../../fileUtils';

//Save  Picture function: this.$emit('photoTaken', { image: this.img, close: true });
//close  this.$emit('close_camera_component_dialog');
export default {
  name: "Camera",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    displayPopup: {
      type: Boolean,
      default: true,
    },
    resolution: {
      type: Object,
      default: () => { return { height: 375, width: 500 } },
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  components: {
    WebCam,
  },
  data: function () {
    return {
      cameraLoading: true,
      showSettings: false,
      devices: [],
      camera: null,
      deviceId: null,
      img: null,
      deviceSelected: '',
      cameraStartStop: true,
      inPreview: false,
      cameraErrorMessage: '',
    };
  },
  computed: {
    videoPreview: function () {
      return `height: ${this.resolution.height}px; width: ${this.resolution.width}px; max-height: ${this.resolution.height}px; max-width: ${this.resolution.width}px; min-height: ${this.resolution.height}px; min-width: ${this.resolution.width}px;`; 
    },
    device: function () {
      return find(this.devices, n => n.deviceId == this.deviceId);
    },
  },
  watch: {
    showDialog: function (value) {
      if (value) {
        this.debounceCamera();
      }
      else {
        this.onStop();
      }
    },
    camera: function (value) {
      if (value)
        this.switchCamera(value);
    },
    cameraStartStop: function (value) {
      if (value)
        this.onStart();
      else
        this.onStop();
    },
    showSettings: function(value) {
      this.saveToLocal();
    }
  },
  mounted() {
    if (this.dipsplayPopup == false)
      document.getElementById('camera-take-images-dialog').scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

    this.findCameras();
    this.showSettings = this.getFromLocal('settings');
  },
  beforeRouteLeave: function (to, from, next) {
    this.onStop();
    next();
  },
  beforeDestroy() {
    this.onStop();
  },
  methods: {
    switchCamera(value) {
      this.cameraLoading = true;
      this.onStop();
      setTimeout(() => {
        //console.log("camera on swithced", value)
        this.deviceId = value;
        this.cameraLoading = false;
        this.saveToLocal();
        //this.onStart();
      }, 1000);
    },
    findCameras() {
      this.devices = [];
      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          //console.log("devices found",devices)
          for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.kind === 'videoinput') {
              this.devices.push({
                deviceId: device.deviceId,
                groupId: device.groupId,
                kind: device.kind,
                label: device.label
              });
            }
          };
          //this.deviceId = this.devices[0].deviceId;
          //this.camera = this.devices[0].deviceId;

          setTimeout(() => { this.selecteDefaultCamera() }, 1000);
        });
    },
    selecteDefaultCamera() {
      if (this.devices.length == 0)
        return;

      this.deviceId = this.devices[0].deviceId;
      this.camera = this.devices[0].deviceId;
      this.onStart();
      let temp, local = this.getFromLocal('camera'); 
      
      //console.log('local', local)
      if (local == null || local == '') {
        temp = this.devices.filter(a => a.label.toLowerCase().includes('back'));
        if (temp != null && temp.length > 0)
          local = temp[0].deviceId
      }        

      if (local != null && local.length > 0) {
        this.deviceId = local;
        this.camera = local;
      }
      else {
        this.deviceId = this.devices[0].deviceId;
        this.camera = this.devices[0].deviceId;
      }

      if (local == null || local == '')
        this.saveToLocal();
    },
    debounceCamera() {
      let cameraRefsExists = false;

      for (let i = 0; i < 4; i++) {
        if (!cameraRefsExists) {
          setTimeout(() => {
            if (this.$refs.webcam != null) {
              this.$refs.webcam.start();
              cameraRefsExists = true;
            }              
          }, 750);
        }
      }
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      //this.$forceUpdate();
      this.inPreview = true;
    },
    closeCamera() {
      this.onStop();
      this.$root.$emit('close_camera_component_dialog');
      this.$emit('close_camera_component_dialog');
    },
    onStarted(stream) {
      if (stream && stream.active)
        this.cameraErrorMessage = '';
      //console.log('On Started Event', stream);
    },
    onStopped(stream) {
      //console.log('On Stopped Event', stream);
    },
    async onStop() {
      
      if (this.$refs.webcam != null) {
        this.$refs.webcam.stop();
      }
        
    },
    onStart() {
      this.$refs.webcam.start();
      //console.log("on start", this.$refs.webcam)
    },
    onError(error) {
      let msg = '';
      if (error == 'NotAllowedError: Permission denied') {
        msg = this.$t('common.CameraPermissionError');
      }
      else
        msg = error;

      if (this.showError)
        this.$alertMsg(msg, 1);

      this.cameraErrorMessage = error;
    },
    onCameras(cameras) {
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      //console.log('On Camera Change Event', deviceId);
    },
    savePhoto() {
      this.inPreview = false;

      this.$emit('photoTaken', { image: this.img, close: true });
      this.$root.$emit('photoTaken', { image: this.img, close: true });

      if (this.displayPopup == true)
        this.onStop();        
    },
    discardPhoto() {
      this.img = null;
      this.inPreview = false;
    },
    saveToLocal() {
      this.$localStorage.set('_selectedCameraId', JSON.stringify({ settingsOpen: this.showSettings, cameraId: this.deviceId } ));
    },
    getFromLocal(item) {
      let loc = JSON.parse(this.$localStorage.get('_selectedCameraId'));

      if (item == 'camera') {
        return loc && loc.cameraId != '' ? loc.cameraId : '';
      }
      else if (item == 'settings') {
        return loc && loc.settingsOpen === true;
      }
    }
  }
};
